module.exports = __webpack_public_path__ + "static/02-6957836c5f6cba64aac59f27f61b3662.jpg";